import { PaletteMode } from '@mui/material';
export const THEMES: { [key: string]: PaletteMode } = {
  dark: 'dark',
  light: 'light',
};
